import React, { useState, useEffect } from "react";
import { getData } from "app/data";
import Hero from "./Hero";
import CommonUseCases from "components/CommonUseCases";
import WaitingFor from "components/Banner/WaitingFor";
import ContentsTwoColumn from "components/SoftwareSolution/ContentsTwoColumn";
import HeaderBackground from "components/BackGround/HeaderBackground";
import { ReactComponent as LeftBox } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightBox } from "images/background/right-box-graphic.svg";
import BenefitsCard from "./BenefitsCard";
import classes from "./Kiosk.module.css";
import PageHeader from "components/PageHeader/TitleSubtitlePageHeader";
import { useSmoothScroll } from 'components/Main/pages/MerchantService/useSmoothScroll.js';

const Index = () => {
  const { myRef, clickHandle } = useSmoothScroll();

  const heroData = getData("kioskData")[0];
  const kioskData = getData("kioskData")[1];
  const [activeBtn, setActiveBtn] = useState();
  useEffect(() => {
    let urlArr = window.location.pathname.split("/");
    if (urlArr.includes("software-solution")) {
      setActiveBtn(true);
    } else if (urlArr.includes("software-solution-kiosk")) {
      setActiveBtn(false);
    }
  }, []);
  return (
    <>
      <PageHeader title="software_solution"
        subtitle="software_sec_header_desc"
        subtitle2="kiosk_title"
        subtitleColorGreen={true}
        activeBtn={activeBtn}
        clickHandle={clickHandle}
      />
      <hr></hr>
      <div className={classes["kiosk-root"]} >
        <HeaderBackground />
        <Hero data={heroData} header={true} />
        <div className={classes.background} ref={myRef}>
          <LeftBox className={classes["left-box-bg"]} />
          <RightBox className={classes["right-box-bg"]} />
          <LeftBox className={classes["left2-box-bg"]} />
          <RightBox className={classes["right2-box-bg"]} />
          <div className={classes.spacer} />
          <div className={classes["section-title-wrapper"]}>
            <h1 className={classes["section-title"]}>
              {kioskData.solutions_title}
            </h1>
          </div>
          <ContentsTwoColumn data={kioskData.solutions} />
          <div className={classes.spacer} />
          <div className={classes["section-title-wrapper"]}>
            <h1 className={classes["section-title"]}>
              {kioskData.benefits_title}
            </h1>
          </div>
          <div className={classes.benefits}>
            {kioskData.benefits.map((benefit, index) => (
              <BenefitsCard key={index} benefit={benefit} />
            ))}
          </div>
          <div className={classes.spacer} />
        </div>
        {/* youtube problem */}
        {/* <div className={classes["software_solution_video"]}>
          <iframe width="1280" height="720" src="https://www.youtube.com/embed/CFHlBDGw-zo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div> */}
        <CommonUseCases data="useCaseData" />
        <WaitingFor />
      </div>
    </>
  );
};
export default Index;
